import climb0 from 'images/climbs/climb_0.png'
import climb1 from 'images/climbs/climb_1.png'
import climb2 from 'images/climbs/climb_2.png'
import climb3 from 'images/climbs/climb_3.png'
import climb4 from 'images/climbs/climb_4.png'
import climb5 from 'images/climbs/climb_5.png'
import climbEvent from 'images/climbs/climb_event.png'
import climbHC from 'images/climbs/climb_hc.png'

export const CLIMB_ICONS = {
  climb0,
  climb1,
  climb2,
  climb3,
  climb4,
  climb5,
  climbevent: climbEvent,
  climbhc: climbHC,
}
